<div class="dialog-backdrop" (click)="closeDialog()"></div>

<section class="dialog-panel" role="dialog" aria-modal="true">
    <header class="dialog-header">
        <h2>Artikel zur Bestellung hinzufügen</h2>

        <button type="button" class="close-button" (click)="closeDialog()">
            <mat-icon fontSet="material-icons-outlined">close</mat-icon>
        </button>
    </header>

    <div class="dialog-search">
        <mat-icon fontSet="material-icons-outlined">search</mat-icon>

        <input type="text" placeholder="Artikel suchen..." [value]="searchTerm()" (input)="updateSearchTerm($event)" />

        @if (searchTerm()) {
        <button type="button" class="search-clear-button" (click)="searchTerm.set('')">
            <mat-icon fontSet="material-icons-outlined">close</mat-icon>
        </button>
        }
    </div>

    <div class="article-list">
        @if (filteredArtikel().length === 0) {
        <div class="empty-state">
            @if (searchTerm().trim()) {
            <mat-icon fontSet="material-icons-outlined">search_off</mat-icon>
            }

            <span>
                {{
                searchTerm().trim()
                ? 'Kein Artikel gefunden.'
                : 'Alle verfügbaren Artikel sind bereits in der Bestellung.'
                }}
            </span>
        </div>
        } @else {
        @for (artikel of filteredArtikel(); track artikel.nummer) {
        <article class="article-option">
            <div class="article-info">
                <span class="article-number">{{ artikel.nummer }}</span>

                <div>
                    <strong>{{ artikel.name }}</strong>
                    <small>{{ artikel.beschreibung }}</small>
                </div>
            </div>

            <button type="button" class="add-button" (click)="addArtikel(artikel)">
                <mat-icon fontSet="material-icons-outlined">add</mat-icon>
                Hinzufügen
            </button>
        </article>
        }
        }
    </div>
</section>